import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Switch from './Switch'
import Popover from '../ui/Popover'

/*
 * API Structure
{
  admin: true,
  content: ['read', 'update', 'create', 'delete'] (all)
  content_type: ['read', 'update', 'create', 'delete'] (all)
  setting_set: ['read', 'update', 'create', 'delete'] (all)
  setting: ['read', 'update', 'create', 'delete'] (all)
  user_role: ['read', 'update', 'create', 'delete'] (all)
  user: ['read', 'update', 'create', 'delete'] (all)
  ['content_type_id']: ['read', 'update', 'create', 'delete']
  ['user_role_id']: ['read', 'update', 'create', 'delete']
  ['setting_set_id']: ['read', 'update', 'create', 'delete']
}
*/

@connect(({types, roles}) => ({types, roles}))
export default class extends React.Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    editable: PropTypes.bool
  }

  state = {
    addTypes: []
  }

  checkValue (key, value) {
    if (!value) {
      return !!this.props.value[key]
    }
    if (Array.isArray(value)) {
      return JSON.stringify(this.props.value[key]) === JSON.stringify(value)
    }
    if (typeof value === 'string') {
      return this.props.value[key] && this.props.value[key].indexOf(value) > -1
    }
  }

  updateValue (key, value, checked) {
    let newValue = checked

    if (Array.isArray(value)) {
      newValue = checked ? value : []
    }

    if (typeof value === 'string') {
      if (checked) {
        newValue = this.props.value[key] ? this.props.value[key].concat(value) : [value]
      } else {
        const index = this.props.value[key].indexOf(value)
        if (index > -1) {
          newValue = [
            ...this.props.value[key].slice(0, index),
            ...this.props.value[key].slice(index + 1)
          ]
        }
      }
    }

    return {
      ...this.props.value,
      [key]: newValue
    }
  }

  addPermission (key, e) {
    e.preventDefault()
    let addTypes = []
    switch (key) {
      case 'content':
        addTypes = this.props.types
        break
      case 'setitng':
        addTypes = this.props.settings
        break
      case 'user':
        addTypes = this.props.roles
        break
    }

    console.log(this.props)
    console.log(addTypes)

    this.setState({addTypes}, () => {
      this.refs.popover.setState({showing: true, target: e.target})
    })
  }

  onChange (key, value, checked) {
    const newValue = this.updateValue(key, value, checked)
    console.log(newValue)
    this.props.onChange(newValue)
  }

  renderSwitch (permission, i) {
    const {label, key, value} = permission
    const checked = this.checkValue(key, value)

    return (
      <div key={i + key} className='permission-switch'>
        <label>{label}</label>
        {this.props.editable
          ? <Switch value={checked} onChange={this.onChange.bind(this, key, value)} />
          : null
        }
      </div>
    )
  }

  render () {
    let contentSwitches = []
    let settingsSwitches = []
    let userSwitches = []
    const {value} = this.props

    if (!value.admin) {
      contentSwitches.push({key: 'content_type', value: 'read', label: 'Access content section'})
      if (this.checkValue('content_type', 'read')) {
        contentSwitches.push({key: 'content_type', value: ['read', 'update', 'create', 'delete'], label: 'Manage content types'})
        contentSwitches.push({key: 'content', value: ['read', 'update', 'create', 'delete'], label: 'Manage all content'})
      }

      userSwitches.push({key: 'user_role', value: 'read', label: 'Access user section'})
      if (this.checkValue('user_role', 'read')) {
        userSwitches.push({key: 'user_role', value: ['read', 'update', 'create', 'delete'], label: 'Manage user roles'})
        userSwitches.push({key: 'user', value: ['read', 'update', 'create', 'delete'], label: 'Manage all users'})
      }
    }

    if (value.admin) {
      return (
        <div className='panel'>{this.renderSwitch({key: 'admin', label: 'Admin access'})}</div>
      )
    }

    return (
      <div className='panel'>
        {this.renderSwitch({key: 'admin', label: 'Admin access'})}
        <div className='permission-group'>
          Content
          <button type='button' onClick={this.addPermission.bind(this, 'content')}>Add</button>
        </div>
        {contentSwitches.map(this.renderSwitch.bind(this))}
        <div className='permission-group'>
          Users
          <button type='button' onClick={this.addPermission.bind(this, 'user')}>Add</button>
        </div>
        {userSwitches.map(this.renderSwitch.bind(this))}
        <Popover ref='popover'>
          <select>
            {this.state.addTypes.map((model) => {
              return (
                <option value={model.id} key={model.id}>{model.name}</option>
              )
            })}
          </select>
        </Popover>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/RolePermissions.js